export const mockMemberStats = {
  inquiries: 7,
  reports: 4,
  properties: 3,
};

export const mockMemberInquiries = [
  {
    id: 201,
    name: 'Rajesh Kumar',
    subject: 'Interested in leasing 5-acre plot near NH-48 for solar farm',
    status: 'in_progress',
    listing_title: '5 Acre Agri Land — Sohna Road, Gurgaon',
    created_at: '2026-07-15T10:30:00Z',
  },
  {
    id: 198,
    name: 'Anita Sharma',
    subject: 'Request for site visit — warehouse plot B-12',
    status: 'contacted',
    listing_title: '2.75 Acre Industrial Plot — Bhiwandi, Mumbai',
    created_at: '2026-07-10T14:15:00Z',
  },
  {
    id: 187,
    name: 'Vikram Reddy',
    subject: 'Need land for organic farming — 10+ acres preferred',
    status: 'new',
    listing_title: '12 Acre Farmland — Zaheerabad, Telangana',
    created_at: '2026-07-08T09:00:00Z',
  },
  {
    id: 175,
    name: 'Priya Menon',
    subject: 'Wind energy feasibility inquiry for 3 sites in Tamil Nadu',
    status: 'qualified',
    listing_title: '15 Acre Wind Zone — Tirunelveli, Tamil Nadu',
    created_at: '2026-06-28T16:45:00Z',
  },
  {
    id: 162,
    name: 'Sunil Patil',
    subject: 'Follow-up: Joint venture proposal for resort development',
    status: 'converted',
    listing_title: '8 Acre Hill View Plot — Lonavala, Maharashtra',
    created_at: '2026-06-20T11:20:00Z',
  },
];

export const mockMemberReports = [
  {
    id: 55,
    location: 'NH-48 Corridor, Sohna, Gurgaon — 5 Acres',
    status: 'completed',
    land_size_acres: 5,
    created_at: '2026-07-16T08:00:00Z',
  },
  {
    id: 48,
    location: 'Bhiwandi Industrial Zone, Mumbai — 2.75 Acres',
    status: 'completed',
    land_size_acres: 2.75,
    created_at: '2026-07-11T12:30:00Z',
  },
  {
    id: 41,
    location: 'Tirunelveli Wind Corridor, Tamil Nadu — 15 Acres',
    status: 'processing',
    land_size_acres: 15,
    created_at: '2026-07-05T09:15:00Z',
  },
  {
    id: 33,
    location: 'Lonavala Hill Tract, Maharashtra — 8 Acres',
    status: 'completed',
    land_size_acres: 8,
    created_at: '2026-06-22T14:50:00Z',
  },
];